/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Op_GteInputs */

const cs_op_gte = /** @type {(inputs: Op_GteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`>=`)
};

const en_op_gte = /** @type {(inputs: Op_GteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`>=`)
};

/**
* | output |
* | --- |
* | ">=" |
*
* @param {Op_GteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const op_gte = /** @type {((inputs?: Op_GteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Op_GteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_op_gte(inputs)
	return cs_op_gte(inputs)
});